import { useState } from 'react';
import { message } from '@bfe/lux';
import { ls } from '@sfe/bone-cache';

import { uniframeReady } from '@spot-fe/utils';
import { useI18n, useUserInfo } from '@spot-fe/base-ui';

export interface TransferProps {
  handleTransferComplete?: () => void;
  coin?: string;
  theme?: 'light' | 'dark';
}
export function useTransfer({
  coin,
  theme = 'light',
  handleTransferComplete,
}: TransferProps) {
  const { t } = useI18n();
  const { userInfo, isUTA, isUnified, isSub, isFA } = useUserInfo();
  const [isLoading, setIsLoading] = useState(false);
  const [readyState, setReadyState] = useState(-1);

  const init = async () => {
    await uniframeReady();
    (window as any)?.BybitUniFrame?.ready(({ transfer }) => {
      const {
        THEME,
        DEFAULT_FROM,
        DEFAULT_TO,
        LOCK_ACCOUNTS,
        VISIBILE,
        PATH_NAME,
        DIRECTION,
      } = transfer.properties;
      const { HIDE_MODAL, TRANSFER_COMPLETE, TRANSFER_FAIL } = transfer.events;
      const accountEnum = {
        // 统保账户
        UNIFIED: 'ACCOUNT_TYPE_UNIFIED',
        // 现货账户
        SPOT: 'ACCOUNT_TYPE_SPOT',
        // 通用账户（合约账户）
        CONTRACT: 'ACCOUNT_TYPE_CONTRACT',
        // 资金账户
        FUND: 'ACCOUNT_TYPE_FUND',
      };
      const toAccount = isUTA ? accountEnum.UNIFIED : accountEnum.SPOT;
      let fromAccount = '';
      if (isFA) {
        fromAccount = isSub ? accountEnum.CONTRACT : accountEnum.FUND;
      } else if (isUTA) {
          fromAccount = accountEnum.SPOT;
      } else if (isUnified) {
          fromAccount = accountEnum.UNIFIED;
      } else {
          fromAccount = accountEnum.CONTRACT;
      }

      transfer
        .init()
        .then(() => {
          setReadyState(1);
        })
        .catch(() => {
          setReadyState(0);
        });
      const currTheme = theme ?? (ls.get('BYBIT_THEME_KEY') || 'dark');
      transfer
        .setProperty(THEME, currTheme)
        .setProperty(DEFAULT_FROM, fromAccount) // 如果是统保账户默认为统保账户
        .setProperty(DEFAULT_TO, toAccount)
        .setProperty(LOCK_ACCOUNTS, [toAccount])
        .setProperty(DIRECTION, 'one');

      transfer.setProperty(PATH_NAME, 'spotLending');

      transfer
        .subscribeEvent(HIDE_MODAL, () => {
          transfer.setProperty(VISIBILE, false);
          setIsLoading(false);
        })
        .subscribeEvent(TRANSFER_COMPLETE, () => {
          handleTransferComplete?.();

          transfer.setProperty(VISIBILE, false);
        })
        .subscribeEvent(TRANSFER_FAIL, (res) => {
          if (res && res.data && res.data.ret_code === 90015) {
            message.error(t('transferableBalanceNotEnough'));
          } else {
            message.error(t('currentOperationFailed'));
          }
        });
    });
  };

  const setVisible = async () => {
    try {
      if (!userInfo) return;
      if (readyState !== 1) {
        setIsLoading(true);
        await init();
        // setIsLoading(false);
      }
      if ((window as any)?.BybitUniFrame?.transfer) {
        const { transfer } = (window as any).BybitUniFrame;
        const { COIN, VISIBILE } = transfer.properties;
        transfer.setProperty(COIN, coin).setProperty(VISIBILE, true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return {
    openTransferModal: setVisible,
    transferInitLoading: isLoading,
  };
}
